<template>
	<v-card outlined    
        elevation   = "10"
		style       = " width       : 100%; 
                        height      : 100%; 
                        object-fit  : fill; 
                        overflow-y  : hidden;
                        overflow-x  : hidden" 
       >
		 <v-system-bar 
            lights-out dark 
            class  = "vue-draggable-handle"            
            height = "25"
        >
        	 <template>
        	 	<v-icon small color = "" > mdi-table</v-icon>
                <span :class = "$vuetify.theme.dark ? 'white--text subtitle-2 text-uppercase ' : 'black--text subtitle-2 text-uppercase '">                     
                    {{ nameIframe }} 
                </span>
                <v-spacer></v-spacer>
                <v-btn x-small @click="showText" v-show ="!show.text" color="warning" > Reconfigure</v-btn>
                <v-btn icon x-small 
                    class   = "error ml-7 my-1"
                    @click  = "closeComponent()"                    
                >
                    <v-icon x-small outlined color = "white" class = "ml-1"> mdi-close </v-icon>
                </v-btn> 
        	 </template>
        </v-system-bar>
        <v-card-text class = "no-drag " 
            style = " width         : 100%; 
                      height        : 100%; 
                      object-fit    : fill; 
                      padding       : 2px;" 
            :ref  = "'iframe' + layout_id"
        >
	        <v-row v-show 			= "show.text">
	        	<v-col>
	        		<v-text-field
			            dense
						outlined
						hide-details
			            label="Name"
			            v-model="nameIframe"
						
			          ></v-text-field>
	        	</v-col>
	        	<v-col>
		        	<v-textarea
		        		dense
						outlined
						auto-grow
						hide-details
						:key 			= "'field' + ID_notification + layout_id"
						v-model 		= "info"
						label 			= "Iframe-Text"
						placeholder 	= "Write code" 								
						row-height 		= "15"
						rows 			= "2"						
		        	></v-textarea>
	        	</v-col>
	        	<v-col>	        		
	        		<v-btn color="primary" @click="save()"> {{ $ml.get(btnAction) }}</v-btn>
	        	</v-col>
	        	<v-col cols="12">
	        	</v-col>
	        </v-row>
	        <div :id="'iframe'+layout_id" :style="`height: 100%;`"></div>
        </v-card-text>
	</v-card>
</template>
<script type="text/javascript">
	export default{
		name : "Iframe",
		props : ["info_to_component", "layout_id"],
		data : ()=>({
			info : "",
			nameIframe : "",
			btnAction : "save",
			show : { text : true, },
			ID_notification : "Iframe-component"
		}),
		mounted(){
			if (this.info_to_component) {
				if (this.info_to_component.nameIframe) {
					this.nameIframe = this.info_to_component.nameIframe;
				}
				if (this.info_to_component.info) {
					this.info = this.info_to_component.info;
					this.renderIframe(this.info);
				}
				
			}
		}, 
		/*computed:{
			currentHeight : function(){
				if (this.$refs && this.$refs['iframe' + this.layout_id]) {
					return this.$refs['iframe' + this.layout_id].clientHeight - 50;
				}
			}
		}, */
		methods : {
			save(){
				this.renderIframe(this.info);
				this.updateComponent();
				this.$EventBus.$emit("notifications_modal",{
					type : "saved",
					message : "ELement of "+ this.nameIframe

				})
			}, 
			updateComponent(){
				if (this.layout_id) {						
					this.$emit('update_of_component',{
						component : "Iframe",
						value 	  : { 						
							info  :this.info,
							nameIframe : this.nameIframe, 
						},
						ID 		  : this.layout_id,
					});
				}
			}, 
			showText(){
				this.show.text = !this.show.text;
			},
			renderIframe(text){
				const iframeEl = document.getElementById("iframe"+this.layout_id);
				if (iframeEl) {
					
					if (iframeEl.lastElementChild) {
						iframeEl.lastElementChild.remove();
					}

					// const divEl = document.createElement("div");
					// divEl.style.height = "100%";
					// divEl.style.width = "100%";
					iframeEl.innerHTML = text; // 
					// iframeEl.appendChild(divEl)
				}
				this.showText();
			},
			closeComponent(){
				this.$emit('close_component', this.layout_id);
			},

		}, // methods
	};
</script>